/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */

import * as React from 'react';

import { CheckSquare } from '../icons/check-square';
import { StarIcon } from '../icons/star-icon';
import { ResourcesSection } from './resources.styles';

interface ResourcesProps {
  resourcesTitle: string;
  resourcesDescription: string;
  resources: any[];
}

const Resources = ({ resources, resourcesDescription, resourcesTitle }: ResourcesProps) => {
  return (
    <ResourcesSection id="main-resources">
      <div className="content">
        <div className="content-info">
          <div
            dangerouslySetInnerHTML={{
              __html: resourcesTitle,
            }}
          />
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: resourcesDescription,
            }}
          />
        </div>
        <div className="resources-container">
          {resources.map((resource, index) => {
            return (
              <div key={`resource-${index}`} className="resources">
                <div
                  className="resource-title"
                  dangerouslySetInnerHTML={{
                    __html: resource.title,
                  }}
                />
                <div className="resources-content">
                  {resource.resources_items.map((resource_item, position: number) => {
                    return (
                      <div key={`resource-item-${position}`} className="resource-item">
                        <div>
                          <CheckSquare />
                        </div>
                        <div>
                          <div className="resource-item-title-container">
                            <div
                              className="resource-item-title"
                              dangerouslySetInnerHTML={{
                                __html: resource_item.title,
                              }}
                            />
                            <div>
                              {resource_item.featured && (
                                <div className="featured-badge">
                                  <div>
                                    <StarIcon />
                                  </div>
                                  destaque
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            className="resource-item-description"
                            dangerouslySetInnerHTML={{
                              __html: resource_item.description,
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </ResourcesSection>
  );
};

export { Resources };
